import React from "react";
import "./story.style.css";
import YouTube from "react-youtube";

const Story = () => {
  return (
    <section
      className="story"
      id="about-swagat-vyas"
      aria-labelledby="about-swagat-vyas-title"
    >
      <div className="story-left">
        <h2 id="about-swagat-vyas-title" className="title">
          About Swagat Vyas – Real Estate Leader in Gujarat
        </h2>

        <h3 className="subtitle">
          Journey of Gujarat’s No.1 Real Estate Entrepreneur
        </h3>

        <p className="desc">
          Swagat Vyas, Managing Director of Vishwanath Builders, shares valuable
          insights on Ahmedabad’s real estate industry in the interview
          <strong> “Why Ahmedabad”</strong>. In this conversation, he discusses
          urban development, investment opportunities, and the future of
          real estate in Gujarat.
        </p>
      </div>

      <div className="story-right">
        <YouTube
          className="video"
          videoId="wsagIIq6BiQ"
          title="Why Ahmedabad – Real Estate Insights by Swagat Vyas"
          opts={{
            width: "100%",
            height: "300",
            playerVars: {
              rel: 0,
              modestbranding: 1,
            },
          }}
        />
      </div>
    </section>
  );
};

export default Story;
